<template>
  <div class="affixDoc">
    <el-form :model="docItem" status-icon ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <p>{{docItem.name}}</p>
        <label class="upload" v-if="docItem.filePath && !isDown">
          <em @click="docXia" class="el-icon-download"></em>
        </label>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        url:''
      }
    },
    props: {
      index: {
        type: Number,
      },
      docItem: {
        type: Object,
      },
        // 门户的附件不允许下载
        isDown: {
            type: Boolean,
        },
    },
    methods:{
      docXia(){
        this.$http({
          method:'get',
          url:`/sys/upload/downfile?filePath=${this.docItem.filePath}`,
          responseType:'blob'
        }).then(res => {
          // let blob = new Blob([res.data],{type:'application/pdf'})
          // this.url = window.URL.createObjectURL(blob);
          let blob = new Blob([res.data])
          let fileName = this.docItem.name
          if('msSaveOrOpenBlob' in navigator){
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          }else {
            let link = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = link;
            a.style.display = 'none';
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
            window.URL.revokeObjectURL(link);
            // this.url = window.URL.createObjectURL(blob);
          }
        })
      }
    },
    mounted() {
      // this.docXia()
    }
  }
</script>

<style scoped>
  em{
    cursor: pointer;
  }
</style>
